/* Message properties travel on the selected jewelry variant in the normal POST. */
(() => {
  'use strict';
  const NB = window.NB;
  NB.messagePrint = {
    prepare(form) {
      const root = form.querySelector('[data-message-print]');
      if (!root?.querySelector('[data-message-check]').checked) return;
      const text = root.querySelector('[data-message-text]');
      if (!text.value.trim() || Array.from(text.value).length > 40) throw new Error(root.dataset.required);
      const sender = root.querySelector('[name="properties[贈り主]"]');
      if (Array.from(sender.value).length > 20) throw new Error(root.dataset.required);
    }
  };
  function init(scope = document) {
    scope.querySelectorAll('[data-message-print]').forEach(root => {
      if (root.__messagePrint) return;
      root.__messagePrint = true;
      const check = root.querySelector('[data-message-check]');
      const text = root.querySelector('[data-message-text]');
      const show = () => {
        root.querySelector('[data-message-panel]').hidden = !check.checked;
        root.querySelectorAll('[data-message-field]').forEach(field => { field.disabled = !check.checked; });
        text.required = check.checked;
      };
      check.addEventListener('change', () => { show(); NB.approval?.invalidate(); });
      root.querySelectorAll('[data-message-field]').forEach(field => field.addEventListener('input', () => {
        root.querySelector('[data-message-counter]').textContent = `${Array.from(text.value).length} / 40`;
        NB.approval?.invalidate();
      }));
      show();
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
